<template lang="pug">
  .component-pagination
    ul.pagination(role='navigation', aria-label='Pagination')
      li.pagination-previous(v-bind:class="{disabled: currentPage===1}")
        a(aria-label="Previous page", v-on:click="updatePage(currentPage-1)", v-if=" currentPage!==1") Previous
          span.show-for-sr page

      li(v-for="(page,index) in pages", v-bind:class="{current: page === currentPage, ellipsis: page === false}")
        a(aria-label="'page '+page" v-on:click="updatePage(page)", v-if="page !== false") {{page}}

      li.pagination-next(v-bind:class="{disabled: currentPage===pageCount || !pageCount}")
        a(aria-label="Next page", v-on:click="updatePage(currentPage+1)", v-if="currentPage!==pageCount && pageCount") Next
          span.show-for-sr page
</template>
<script type="text/babel">
    export default {
        name: '',
        components: {},
        data() {
            return {
                pageCount: null
            }
        },
        created() {

        },
        methods: {
            updatePage(index) {
                this.$emit('pageUpdated', index)
            },
            pagination(c, last) {
                var current = c,
                    delta = 5,
                    left = current - delta,
                    right = current + delta + 1,
                    range = [],
                    rangeWithDots = [],
                    l

                for (let i = 1; i <= last; i++) {
                    if (i == 1 || i == last || i >= left && i < right) {
                        range.push(i)
                    }
                }

                for (let i of range) {
                    if (l) {
                        if (i - l === 2) {
                            rangeWithDots.push(l + 1)
                        } else if (i - l !== 1) {
                            rangeWithDots.push(false)
                        }
                    }
                    rangeWithDots.push(i)
                    l = i
                }

                return rangeWithDots
            }
        },
        computed: {
            pages() {
                var computedPageCount = Math.ceil(this.results / this.perPage)
                if (!this.pageCount === null || computedPageCount > 0) {
                    this.pageCount = computedPageCount
                }

                return this.pagination(this.currentPage, this.pageCount)
            }
        },
        props: [
            'results',
            'perPage',
            'currentPage'
        ]
    }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-pagination
    text-align: center
</style>



// WEBPACK FOOTER //
// Pagination.vue?3d9498f0